import React from 'react';

export interface EventsConfig {
    showCreateReminders?: boolean; // list
}

export const DefaultEventsConfig: EventsConfig = {
    showCreateReminders: false,
};

export const EventsContext = React.createContext<EventsConfig>(DefaultEventsConfig);
export const useEventsConfig = (): EventsConfig => React.useContext(EventsContext);
